const INBOX_INITIALS_PALETTE = [
  { bg: "#dbeafe", color: "#1e40af" },
  { bg: "#dcfce7", color: "#166534" },
  { bg: "#fef3c7", color: "#92400e" },
  { bg: "#fce7f3", color: "#9d174d" },
  { bg: "#e0e7ff", color: "#3730a3" },
  { bg: "#ffedd5", color: "#9a3412" },
];

export function hasChatInboxAvatar(imageUrl) {
  return imageUrl != null && String(imageUrl).trim() !== "";
}

export function getChatInboxInitials(name) {
  if (!name || typeof name !== "string") {
    return "?";
  }

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return "?";
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function getChatInboxInitialsStyle(name) {
  if (!name || typeof name !== "string" || !name.trim()) {
    return INBOX_INITIALS_PALETTE[0];
  }

  const index = name.trim().charCodeAt(0) % INBOX_INITIALS_PALETTE.length;
  return INBOX_INITIALS_PALETTE[index];
}

export function resolveInitialChatSelection(allChatUsers, options = {}) {
  const { targetUserId, supportAdminId, defaultToFirst = true } = options;

  if (!Array.isArray(allChatUsers) || allChatUsers.length === 0) {
    return null;
  }

  if (supportAdminId) {
    const supportChat = allChatUsers.find((chat) =>
      chat.chatUsers?.some((user) => {
        const userId = user.id?.id || user.id?._id || user.id;
        return userId === supportAdminId || user.id === supportAdminId;
      })
    );
    if (supportChat) {
      return supportChat;
    }
  }

  if (targetUserId) {
    const targetChat = allChatUsers.find((chat) => {
      if (chat.isGroupChat) {
        return false;
      }

      return chat.chatUsers?.some((user) => {
        const userId = user.id?.id || user.id?._id || user.id;
        return userId === targetUserId;
      });
    });

    if (targetChat) {
      return targetChat;
    }

    if (!defaultToFirst) {
      return null;
    }
  }

  return defaultToFirst ? allChatUsers[0] : null;
}

export function hasChatMessages(userChat) {
  return Array.isArray(userChat) && userChat.length > 0;
}
